import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Uuemad eespool

  <span style="color:#85c1dc;">**FI:**</span>
  Uusimmat ensin

  <span style="color:#85c1dc;">**RU:**</span>
  Новые сверху
*/
/* @__NO_SIDE_EFFECTS__ */
const m1311 = msg(
  mf`Uuemad eespool`,
  mf`Uusimmat ensin`,
  mf`Новые сверху`,
)

export { m1311 as 'w.saal.reasta.uudsus' }